import { ChallengeDuplicateModal } from './ChallengeDuplicateModal';

export default ChallengeDuplicateModal;
